// Déclaration des functions 
    import functionsFilters from '@/functions/filter.js'
    import { stringify } from 'uuid';
    const alphabetUpper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const alphabetLower = 'abcdefghijklmnopqrstuvwxyz';
    const alphabetUpLow = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersUpper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    
    let functions = {
        listeTypes(listeElements, element){
            let el = element
            listeElements.forEach(type => {
                if(el[type] === undefined){
                    return false
                }else{
                    el = el[type]
                }

            })
    
            return el
        },

        nombrePositif(n) {
            if (n < 0) {
                return -n; // Renvoie la valeur absolue du nombre négatif
            } else {
                return n; // Renvoie le nombre positif inchangé
            }
        },

        count(listeElements, type, id){
            return listeElements.reduce((total, element) => Number(total) + Number(element[type]), 0);
        },

        countDiv(listeElements, type, div){
            return listeElements.reduce((total, element) => Number(total) + (Number(element[type]) / div), 0);
        },

        isObject: function(val) {
            return val instanceof Object;
        },

        countFilterByMultiDeux(listeElement, id, type, typeDeux, typeCount, typeCountDeux){
            let count = 0
            listeElement.forEach(element => {
                element[type].forEach(item =>{
                    if(item[typeDeux] === id){
                        count += Number(item[typeCount][typeCountDeux])
                    }

                })
            })
            return count
        },

        countFilterByDeux(listeElement, id, type, typeDeux, typeCount, typeCountDeux){
            let count = 0
            
            listeElement[type].forEach(element =>{
                if(element[typeDeux] === id){
                    count += element[typeCount][typeCountDeux]
                }

            })
            return count
        },

        countDeux(listeElements, type, typeElement){
            return listeElements.reduce((total, element) => Number(total) + Number(element[type][typeElement]), 0);
        },

        countTrois(listeElements, type, typeElement, typeElementDeux){
            return listeElements.reduce((total, element) => Number(total) + Number(element[type][typeElement][typeElementDeux]), 0);
        },

        calcul: function(listeElements, type){
            let calcul = 0

            listeElements.forEach(element =>{
                calcul += element[type]
            })
            return calcul
        }, 
        
        moyenne(listeElements, type){
            if (listeElements.length === 0) {
                return 0; // Si la liste est vide, la moyenne est zéro
            }

            // Calculer la somme des valeurs
            const somme = listeElements.reduce((acc, element) => {
                if (!isNaN(element[type])) {
                    return acc + parseFloat(element[type]);
                } else {
                    return acc;
                }
            }, 0);

            // Calculer la moyenne
            const moyenne = somme / listeElements.length;

            return moyenne;
        },

        pourcentage(numero, total){
            let pourcentage =  Math.round((numero * 100 / total) * 100) / 100
            let centPourcent =  Math.round((pourcentage - Math.floor(pourcentage)) * 10000 / 100)
            let resultat = {
                pourcentage: pourcentage, 
                centPourcent: centPourcent
            }

            return resultat            
        },

        countLength(listeElements, type, id){
            if(listeElements != undefined){
                return listeElements.filter(element => element[type] === id).length
            }else{
                return 0
            }
        },

        countLengthDeux(element, type, typeDeux, id){
            if(element[type] != undefined){
                return element[type].filter(item => item[typeDeux] === id).length
            }else{
                return 0
            }
        },

        supprimerCaracteres(inputString, sequence) {
            if(sequence != ''){
                // Créer une expression régulière pour trouver toutes les occurrences de la suite de 3 caractères
                const regex = new RegExp(sequence, 'g');
                // Remplacer toutes les occurrences de la suite de 3 caractères par une chaîne vide
                return inputString.replace(regex, '');
            }else{
                return inputString
            }
        },

        replaceVariableJSON(text, items){
            let regex = /{{([\w\-. ]+)}}/g
            let regexPluriel = /{if\([a-zA-Z0-9.]*\s*(>=|<=|==|===|!==|!=|>|<)\s*[a-zA-Z0-9.]*\),\s*[a-zA-Z]\}/g
            let regexOperateur = />=|<=|==|===|!==|!=|>|</g
            let description = text
            const resultsRegex = description.match(regex)
            const resultsRegexPluriel = description.match(regexPluriel)

            if(resultsRegex !== null){
                let matches = resultsRegex.map(match => match.replaceAll('{{', '').replaceAll('}}', '')) || [];

                matches.forEach(match => {
                    let types = match.split('.')


                    let els = this.listeTypes(types, items)
                    console.log(els)
                    description = description.replace('{{'+match+'}}', els)
                })
            }

            if(resultsRegexPluriel !== null){
                let matches = resultsRegexPluriel.map(match => match.replaceAll('{', '').replaceAll('}', '')) || [];
                matches.forEach(match => {
                    let elements = match.split(',')
                    let pluriel = elements[1].replaceAll(' ', '')
                    let operateur = elements[0].match(regexOperateur)[0]
                    let elsCondition = elements[0].replaceAll('if(', '').replaceAll(')', '').split(operateur)
                    let types = elsCondition[0].replaceAll(' ', '').split('.')
                    let els = this.listeTypes(types, items, 'test')

                    if(!isNaN(els)){
                        els = Number(els)
                    }

                    let condition = ''
                    if(isNaN(Number(elsCondition[1].replaceAll(' ', '')))){
                        let conditionTypes = elsCondition[1].replaceAll(' ', '').split('.')
                        condition = this.listeTypes(conditionTypes, items)
                    }else{
                        condition = Number(elsCondition[1].replaceAll(' ', ''))
                    }
                    
                    // console.log(els, condition, operateur, pluriel, this.checkCondition(els.toString(), condition, operateur))
                    if(this.checkCondition(els, condition, operateur)){
                        description = description.replace('{'+match+'}', pluriel)
                    }else{
                        description = description.replace('{'+match+'}', '')
                    }
                })
            }

            return description
        },

        checkCondition(els, condition, operator) {

            if(operator === '>'){
                return Number(els) > Number(condition);
            }else if(operator === '<'){
                return Number(els) < Number(condition);
            }else if(operator === '>='){
                return Number(els) >= Number(condition);
            }else if(operator === '<='){
                return Number(els) <= Number(condition);
            }else if(operator === '=='){
                return els == condition; // Utilisation de == pour comparer les valeurs
            }else if(operator === '==='){
                return els === condition; // Utilisation de == pour comparer les valeurs
            }else if(operator === '!='){
                return els != condition; // Utilisation de != pour comparer les valeurs
            }else if(operator === '!=='){
                return els !== condition; // Utilisation de != pour comparer les valeurs
            }else{
                return false
            }
        },

        removeAccents: function(str){
            return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        },

        strUcFirst(a) {
            return (a+'').charAt(0).toUpperCase() + (a+'').substr(1);
        },

        nbrTelephone(nbr){
            return nbr[0] + nbr[1] +'.'+nbr[2] + nbr[3] +'.'+nbr[4] + nbr[5] +'.'+nbr[6] + nbr[7] +'.'+nbr[8] + nbr[9]
        },

        selectedPoint(typeSlider, slider){
            let mesSliders = document.querySelectorAll('.'+typeSlider)
            let listePointsSlider = document.querySelectorAll('.liste-points-'+slider)
            let monPointActif = document.querySelectorAll('.point-'+slider+'.bg-gris-blanc')
            let hauteurSlider = mesSliders[0].clientHeight
            let scrollTop = mesSliders[0].scrollTop
            monPointActif[0].classList.replace('bg-gris-blanc', 'bg-gris')
            let positionPointActif = Math.floor(scrollTop / hauteurSlider)
            listePointsSlider[0].children[positionPointActif].classList.replace('bg-gris', 'bg-gris-blanc')
        },

        scrollPosition(typeSlider){
            let mesSliders = document.querySelectorAll('.'+typeSlider)
            let hauteurSlider = mesSliders[0].clientHeight
            let scrollTop = mesSliders[0].scrollTop
            let data = {}
            data.scrollPosition = scrollTop
            data.height = hauteurSlider
            if(data.scrollPosition >= data.height / 2){
                data.color = 'bg-gris-fonce'
            }else{
                data.color = 'bg-gris-blanc'
            }
            return data
        },

        scrollToSection(typeSlider, section){
            let mesSliders = document.querySelectorAll('.'+typeSlider)
            let mesSections = document.querySelectorAll('#'+section)

            mesSliders[0].scrollTop = mesSections[0].offsetTop                    
        },

        convertisseurVolumeToBest(nbr){
            let nbrRetour = nbr + 'mL'
            if(nbr >= 1000){
                nbrRetour = new Intl.NumberFormat().format(Math.round(nbr * 1000) / 1000000) + 'L'
            }
            return nbrRetour
        },

        champsToSlug(champs){
            return this.removeAccents(champs).toLowerCase().replaceAll(' ', '-').replace(/[()'"]/g, '')
        },
        
        addSpace(chaine, n){
            let resultat = '';
  
            for (let i = 0; i < chaine.length; i++) {
                // Ajouter l'espace après chaque n caractères
                if (i > 0 && i % n === 0) {
                resultat += ' ';
                }
                
                // Ajouter le caractère courant à la chaîne résultat
                resultat += chaine[i];
            }
            
            return resultat;
        },

        textAdresse(adresse){
            let resultat = adresse.numero_de_rue + ', ' + adresse.adresse + '<br>'
            
            if(adresse.complement_adresse != ''){
                resultat += adresse.complement_adresse + '<br>'
            }

            resultat += adresse.code_postal + ' ' + adresse.ville + '<br>' + adresse.pays
            return resultat
        },

        getMinMaxFromListe(liste){
            let valeurs = Object.values(liste).filter(val => val !== null && val !== undefined && val !== "");
            return {
                min: Number(Math.min(...valeurs)),
                max: Number(Math.max(...valeurs))
            }
        },

        formatDevise(devise){
            let deviseArrondi = Math.round(devise * 100) / 100
            return deviseArrondi.toFixed(2).replace('.', ',')
        }
    }

    export default functions


// WEBPACK FOOTER //
// ./src/functions/functions.js